import React, { Fragment, useContext } from 'react'
import {
  TextField,
  Checkbox,
  StandardTextFieldProps,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
  CircularProgress,
  Typography
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import InfoIcon from '@mui/icons-material/Info'
import SaveIcon from '@mui/icons-material/Save'
import CancelIcon from '@mui/icons-material/Cancel'
import { getTypeInput } from '../../../utils/inputHelper'
import { inputTypeValue } from '../../../const/inputTypeValue'
import { useStyles } from './styles'
import { ConfigurationContext } from '../configurationContext'
import { withStyles } from '@mui/styles'

interface InputConfigurationProps extends StandardTextFieldProps {
  typeValue: string
  toolTipText?: string
  typeConfigurationId?: number
}

export const InputConfiguration: React.FC<InputConfigurationProps> = ({
  typeValue,
  id,
  name,
  label,
  placeholder,
  toolTipText,
  typeConfigurationId,
  onChange
}) => {
  const {
    handleUpdateConfiguration,
    editModeButtons,
    saveModeButtons,
    state,
    dispatch
  } = useContext(ConfigurationContext)
  const { inputName, inputValue, messageServer } = state
  const classes = useStyles()

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f6f6f6',
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 14
    }
  }))(Tooltip)

  return typeValue === inputTypeValue.CARACTER ||
    typeValue === inputTypeValue.TEXTO ||
    typeValue === inputTypeValue.NUMERO_TIPO_INT ||
    typeValue === inputTypeValue.NUMERO_TIPO_DOUBLE ||
    typeValue === inputTypeValue.NUMERO_TIPO_FLOAT ? (
    <Fragment>
      <Grid
        item
        container
        xs={12}
        sm={12}
        md={8}
        lg={8}
        style={{ marginLeft: '30px' }}
      >
        <Grid item xs={12} sm={12} md={10} lg={10}>
          <TextField
            id={id}
            name={name}
            label={label}
            value={inputValue[`${name}`]}
            placeholder={placeholder}
            type={`${getTypeInput(typeValue)}`}
            required
            InputLabelProps={{
              shrink: true,
              classes: {
                root: classes.inputLabel
              }
            }}
            InputProps={{ disabled: inputName !== `${name}` }}
            fullWidth
            onChange={onChange}
            helperText={
              inputName === `${name}` ? (
                <Typography
                  variant='body2'
                  component='p'
                  style={{
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffeeba',
                    color: '#856404',
                    borderRadius: '20px',
                    textIndent: '5px',
                    padding: '5px'
                  }}
                >
                  <b>Advertencia:</b>
                  {` La modificación de parametros podría generar cambios en el sistema.`}
                </Typography>
              ) : (
                ''
              )
            }
          />

          <Typography
            id={`alertConfiguration${name}`}
            variant='body2'
            component='p'
            className={messageServer === '' ? classes.success : classes.error}
            style={{ visibility: 'hidden' }}
          >
            {messageServer === ''
              ? `Parametro modificado exitosamente`
              : `${messageServer}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2} className={classes.root}>
          <Tooltip title='Editar' aria-label='edit'>
            <div className={classes.wrapper}>
              <IconButton
                id={`edit${name}`}
                name={`edit${name}`}
                value={name}
                aria-label='edit'
                onClick={() => editModeButtons(name, true)}
              >
                <EditIcon />
              </IconButton>
            </div>
          </Tooltip>
          <Tooltip title='Guardar' aria-label='save'>
            <div className={classes.wrapper}>
              <IconButton
                id={`save${name}`}
                name={`save${name}`}
                aria-label='save'
                onClick={() => {
                  saveModeButtons(name, true)
                  setTimeout(() => {
                    handleUpdateConfiguration(typeConfigurationId!, name!)
                    saveModeButtons(name, false)
                  }, 2000)
                }}
                style={{ display: 'none' }}
              >
                <SaveIcon />
              </IconButton>

              <CircularProgress
                id={`loader${name}`}
                size={35}
                className={classes.fabProgress}
                style={{ visibility: 'hidden' }}
              />
            </div>
          </Tooltip>

          <Tooltip title='Cancelar' aria-label='cancel'>
            <div className={classes.wrapper}>
              <IconButton
                id={`cancel${name}`}
                name={`cancel${name}`}
                value={name}
                aria-label='cancel'
                onClick={() => editModeButtons(name, false)}
                style={{ display: 'none' }}
              >
                <CancelIcon />
              </IconButton>
            </div>
          </Tooltip>

          <LightTooltip
            title={`${toolTipText}`}
            aria-label='info'
            placement='right'
          >
            <div className={classes.wrapper}>
              <IconButton
                id={`info${name}`}
                name={`infol${name}`}
                aria-label='info'
              >
                <InfoIcon />
              </IconButton>
            </div>
          </LightTooltip>
        </Grid>
      </Grid>
    </Fragment>
  ) : (
    <Fragment>
      <Grid
        item
        container
        xs={12}
        sm={12}
        md={10}
        lg={10}
        style={{ textAlign: 'left', marginLeft: '30px' }}
      >
        <Grid item xs={12} sm={12} md={8} lg={8}>
        <FormControlLabel
  control={
    <Checkbox
      id={id}
      name={name}
      color='primary'
      checked={inputValue[`${name}`] === 'true'}
      onChange={async (e: any) => {
        inputValue[`${name}`] = e.target.checked.toString()
        dispatch({
          type: 'SET_INPUT_VALUE',
          payload: {
            ...inputValue,
            [`${name}`]: inputValue[`${name}`]
          }
        })
        // Intenta actualizar la configuración
        await handleUpdateConfiguration(typeConfigurationId!, name!, true);

      }}
    />
  }
  label={label}
/>
          <Typography
            id={`alertConfiguration${name}`}
            variant='body2'
            component='p'
            className={messageServer === '' ? classes.success : classes.error}
            style={{ visibility: 'hidden' }}
          >
            {messageServer === ''
              ? `Parametro modificado exitosamente`
              : `${messageServer}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2} className={classes.root}>
          <LightTooltip
            title={`${toolTipText}`}
            aria-label='info'
            placement='right'
          >
            <div className={classes.wrapper} style={{ top: '-10px' }}>
              <IconButton
                id={`info${name}`}
                name={`infol${name}`}
                aria-label='info'
              >
                <InfoIcon />
              </IconButton>
            </div>
          </LightTooltip>
        </Grid>
      </Grid>
    </Fragment>
  )
}
